import { render, staticRenderFns } from "./QuizQuestionsCmp.vue?vue&type=template&id=6899e388&scoped=true"
import script from "./QuizQuestionsCmp.vue?vue&type=script&lang=js"
export * from "./QuizQuestionsCmp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6899e388",
  null
  
)

export default component.exports